import config from 'js/app/config';
import { tupleToStringKey } from 'js/lib/stringKeyTuple';
import { useLocation, useParams } from 'js/lib/useRouter';

import { useDegreeDescriptionPageData } from 'bundles/degree-description/contexts/DegreeDescriptionPageContext';
import type { MultiStepEoiContent } from 'bundles/expression-of-interest/components/ddp-multistep/MultiStepEoiSurvey';
import { EOI_SURVEY_VARIANTS } from 'bundles/expression-of-interest/constants';
import { getEoiContext, getEoiCurrentUrl } from 'bundles/expression-of-interest/utils/util';
import { ProductTypes } from 'bundles/university-program-qualification/utils/constants';

const useDegreeEoiSurveyProps = () => {
  const { id, pageContent } = useDegreeDescriptionPageData();
  const { slug } = useParams();
  const location = useLocation();

  const currentUrl = getEoiCurrentUrl({
    baseUrl: config.url.base,
    slug,
    pathname: location.pathname,
    search: location.search ?? '',
  });

  const eoi = pageContent?.expressionOfInterest;

  const content: MultiStepEoiContent = {
    heading: eoi?.multistepEoiHeading ?? undefined,
    subheading: eoi?.multistepEoiSubheading ?? undefined,
    step1Cta: eoi?.multistepEoiStep1Cta ?? undefined,
    step2Cta: eoi?.multistepEoiStep2Cta ?? undefined,
    terminalScreen: {
      heading: eoi?.multistepEoiTerminalStepHeading ?? undefined,
      applyButtonText: eoi?.applyButtonText ?? undefined,
      checklistItems: {
        inboxDetails: eoi?.multistepEoiCheckYourInboxText ?? undefined,
        enrollmentTeam: eoi?.multistepEoiEnrollmentTeamText ?? undefined,
        startApplication: eoi?.multistepEoiApplyAnytimeText ?? undefined,
      },
    },
  };

  return {
    content,
    productId: tupleToStringKey([ProductTypes.DEGREE, id]),
    surveyVariant: EOI_SURVEY_VARIANTS.degreeMultistep,
    eoiContext: getEoiContext(currentUrl),
    applicationUrl: pageContent?.expressionOfInterest?.applyButtonUrl,
  };
};

export default useDegreeEoiSurveyProps;
